import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { formatDate } from '../../utils/Utils';

// P7a (analiz §17 "Kaynaklı değerlendirme taslağı her iddiayı bu kayıtlara bağlar", §33 M74) — AI taslağındaki doğrulanabilir
// ifadelerin dayandığı kayıtlar (hedef, sürekli geri bildirim, 1:1 görüşmesi, 360 sorusu). Sunucu her ifadeyi kanıttaki kayda
// bağlar ve metindeki her sayıyı kanıta karşı doğrular; doğrulanmayan taslak buraya hiç gelmez. Puanı kullanıcı kendisi belirler.
const Box = styled.div`
  margin: 8px 0 16px;
  padding: 10px 12px;
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.bgColor};
`;

const Title = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 6px;
`;

const Row = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.primary};
  padding: 4px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.surface.border};
  &:first-of-type { border-top: none; }
`;

const Chip = styled.span`
  display: inline-block;
  margin: 2px 4px 0 0;
  padding: 1px 6px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  color: ${({ theme }) => theme.colors.text.muted};
`;

const Muted = styled.div`
  margin-top: 6px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
`;

export function sourceLabel(t, lang, src) {
  const type = t(`performance.aiCenter.sourceType.${src.type}`, { defaultValue: src.type });
  if (src.type === 'feedback') {
    return `${type}: ${t(`performance.profile.feedbackCategory.${src.code}`, { defaultValue: src.code || '' })}${src.date ? ` · ${formatDate(src.date, lang)}` : ''}`;
  }
  if (src.type === 'meeting') return `${type}${src.date ? `: ${formatDate(src.date, lang)}` : ''}`;
  return src.label ? `${type}: ${src.label}` : type;
}

export default function AiDraftSources({ draft }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const claims = (draft?.statements || []).filter((s) => s.kind === 'claim');
  if (claims.length === 0) return null;
  return (
    <Box data-section="ai-draft-sources">
      <Title>{t('performance.ai.sourcesTitle')}</Title>
      {claims.map((s) => (
        <Row key={s.ordinal} data-sourced={s.sources.length > 0 ? 'yes' : 'no'}>
          {s.text}
          <div>
            {s.sources.length === 0
              ? <Chip>{t('performance.ai.noSource')}</Chip>
              : s.sources.map((src) => <Chip key={src.ref}>{sourceLabel(t, lang, src)}</Chip>)}
          </div>
        </Row>
      ))}
      <Muted>{t('performance.ai.sourcesSummary', { sourced: draft.sourcedCount ?? 0, total: draft.verifiableCount ?? claims.length })}</Muted>
    </Box>
  );
}
